import { useEffect, useState } from "react";
import Icons from "../../../../components/icons";
import { useAppServices } from "../../../../hook/services";
import { useNavigate } from "react-router-dom";
import LogoutIcon from '@mui/icons-material/Logout';
import { useUserInfo } from "../../../../context/user";

const IntegrationTopbar = ({ account_id }) => {
    const [agency, setAgency] = useState(null);
    const Service = useAppServices();
    const navigate = useNavigate()
    const logout = useUserInfo()[2];
    const getting_whitelable_domain = async () => {
        const currentURL = window.location.href;
        const urlObject = new URL(currentURL);
        const domain = urlObject.hostname;
        const payload = {
            domain: domain,
        };
        const { response } = await Service.agency.getwhitelabel({
            payload: payload,
        });
        const { response: agency_response } = await Service.agency.getAgency({
            query: `_id=${domain?.includes("localhost")
                ? "6739f1be347a7f5974735cec"
                : response?.data?._id
                }`,
        });
        if (agency_response?.data) {
            setAgency(agency_response?.data);
        }
    };

    useEffect(() => {
        getting_whitelable_domain();
    }, []);


    return (
        <div className="w-full py-4 px-3 bg-white border-b flex items-center justify-between">
            <div>
                {agency?.Customization?.logo ? (
                    <img
                        src={agency?.Customization?.logo}
                        alt="logo"
                        style={{ maxWidth: "98px", maxHeight: "28px", paddingLeft: "10px" }}
                    />
                ) : (
                    <Icons id="maybeIcon" />
                )}
            </div>
            <div> {window.location.pathname.includes(`/integration-app/sign-up`) ? <p className="text-[#757575]">
                Already have an account?{" "}
                <button
                    onClick={() => {
                        navigate(`/integration-app/sign-in?id=${account_id}`);
                    }}
                    className="text-[#1E1E1E]"
                >
                    Sign in
                </button>
            </p> : window.location.pathname.includes(`/integration-app/sign-in`) ? <p className="text-[#757575]">
                Do not have an account?{" "}
                <button
                    onClick={() => {
                        navigate(`/integration-app/sign-up?id=${account_id}`);
                    }}
                    className="text-[#1E1E1E]"
                >
                    Sign up
                </button></p> :
                <button
                    onClick={() => logout()}
                    className="flex items-center gap-2 mr-2"
                >
                    <LogoutIcon sx={{ color: "#949fae" }} fontSize="22px" /><span className="text-[#949fae] font-bold">Logout</span>
                </button>}</div>
        </div>
    );
};

export default IntegrationTopbar;
